var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Box, Text, SkeletonCircle, SkeletonText } from '@noom/wax-component-library';
import Avatar from '../../../../core/components/Avatar';
import Time from '../../../../core/components/Time';
import { Highlight } from './Hightlight';
const BadgeSizeMap = {
    xs: 3,
    sm: 4,
};
export function Badge(_a) {
    var { children, size, onClick } = _a, style = __rest(_a, ["children", "size", "onClick"]);
    return (React.createElement(Box, Object.assign({ bg: "primary.500", p: 0.5, h: BadgeSizeMap[size], w: BadgeSizeMap[size], color: "white", borderRadius: "full", boxShadow: "md", fontSize: "0.6rem", display: "flex", justifyContent: "center", alignItems: "center", onClick: onClick }, style), children));
}
export function RecordLayout(_a) {
    var { avatar, title, subTitle, badge, onClick } = _a, style = __rest(_a, ["avatar", "title", "subTitle", "badge", "onClick"]);
    return (React.createElement(Box, Object.assign({ w: "100%", p: 3, display: "flex", flexDir: "row", borderWidth: 1 }, style, { onClick: onClick }),
        avatar,
        React.createElement(Box, { display: "flex", flexDir: "column", pl: 3, flex: 1 },
            React.createElement(Box, null, title),
            React.createElement(Box, null, subTitle)),
        React.createElement(Box, { display: "flex", alignItems: "center", p: 3 }, badge)));
}
export function NotificationRecordItem(_a) {
    var _b, _c, _d, _e;
    var { onClick, onBadgeClick, record } = _a, style = __rest(_a, ["onClick", "onBadgeClick", "record"]);
    const { sourceType, description, imageUrl, serverTimeUpdated, read } = record;
    const handleClick = () => {
        onClick === null || onClick === void 0 ? void 0 : onClick(record);
    };
    const handleBadgeClick = (event) => {
        event.stopPropagation();
        event.preventDefault();
        onBadgeClick === null || onBadgeClick === void 0 ? void 0 : onBadgeClick(record);
    };
    return (React.createElement(RecordLayout, Object.assign({ cursor: "pointer", onClick: handleClick, avatar: React.createElement(Avatar, { avatar: imageUrl, displayName: (_c = (_b = record.actors) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.name, isCommunity: sourceType === 'COMMUNITY' }), title: React.createElement(Highlight, { query: (_e = (_d = record.actors) === null || _d === void 0 ? void 0 : _d.map((a) => a.name)) !== null && _e !== void 0 ? _e : [], styles: { color: 'primary.500', fontWeight: '500' }, allowDuplicate: false }, description), subTitle: React.createElement(Text, { size: "xs", color: "gray" },
            React.createElement(Time, { date: Date.parse(serverTimeUpdated), className: "" })), badge: !read && React.createElement(Badge, { size: "xs", onClick: handleBadgeClick }) }, style)));
}
export function NotificationRecordSkeleton(style) {
    return (React.createElement(RecordLayout, Object.assign({ avatar: React.createElement(SkeletonCircle, { h: 10, w: 10 }), title: React.createElement(SkeletonText, { noOfLines: 2, w: "100%" }), subTitle: React.createElement(SkeletonText, { noOfLines: 1, w: "30%", mt: 2 }), badge: React.createElement(SkeletonCircle, { h: 2, w: 2 }) }, style)));
}
//# sourceMappingURL=NotificationRecordItem.js.map